import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AssistBotService } from '../assist-bot.service';
import * as CryptoJS from 'crypto-js';
import { NotifierService } from 'angular-notifier';
import { LoginService } from '../../../../components/login/service/login.service';
import { error } from 'jquery';
 
 
 
declare const $:any;

@Component({
  selector: 'app-bot',
  templateUrl: './bot.component.html',
  styleUrls: ['./bot.component.scss']
})
export class BotComponent {
  
  volumeicons:any=["fa fa-volume-off","fa fa-volume-up"];
  @Input() data:any;
 
  @Input() index:any;
  @Input() speakeLanguage:any;
 
  showPaginateSpinner:boolean=false;

  public isActiveFeedback: boolean = false;

  synth = window.speechSynthesis;

  commentForm:FormGroup=new FormGroup({});
  showuserIcon:boolean=false;

  userDetails:any;
   llm_url:any;
  constructor(private fb:FormBuilder,@Inject(DOCUMENT) private document:Document,private notifier: NotifierService,
 private http:HttpClient,private assistBotService:AssistBotService,private service:LoginService){

  }

  ngOnInit(){
  let user = localStorage.getItem("user");
                    if(user){
                      var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
                      this.userDetails = JSON.parse(data);
                    }   
  this.llm_url = "https://document.canstringai.com:8443/upload_document/";
    
    this.commentForm = this.fb.group({
      'comment':new FormControl('',Validators.required)
    });
     // this.data['answer']='The California Paid Family Leave (PFL) policy is a state disability insurance program that provides wage replacement benefits to eligible workers who need to take time off work to care for a seriously ill family member or to bond with a new child. The policy covers various family members including children, parents, parent-in-laws, grandparents, grandchildren, siblings, spouses, and registered domestic partners. There is no waiting period or relapse period for the PFL policy. '
   this.showPaginateSpinner= true;
   if(this.data.bot_answer){
    this.showPaginateSpinner = false;
   }

    let headers:any = new Headers();
    headers.append('Content-Type', 'application/json');

    if(this.data?.search && this.data?.bot_type!=="suggestion"){

      this.showPaginateSpinner= true;
      const payload = {
        "query":this.data.question,
        "clientid":this.userDetails['userid']
      }

      this.http.post( this.llm_url+"query", payload, {headers: headers}).subscribe(
        {
          next:(response:any)=>{
      
        this.showPaginateSpinner= false;
  
        let user_id = this.userDetails['userid'];
        let botPayload ={
        "user_id":user_id,
        "question":payload["query"],
        "answer":response['result'],
        "question_type":"history",
        "bot_type":"bot",
        "sequence_id":new Date().valueOf()
        };
            this.data["question_type"]="history";
            this.data["sequence_id"]=new Date().valueOf();
            this.data["created_at"] = new Date();
            this.data['bot_answer']=response['result'];
            this.data["search"] = false;

     
        // this.assistBotService.createHistory(botPayload).subscribe((result:any)=>{
          
        //   if(result['success']){
          
        //     this.data["question_type"]="history";
        //     this.data["sequence_id"]=result['createdMessage']["sequence_id"];
        //     this.data["history_id"] = result['createdMessage']["history_id"];
        //     this.data["created_at"] = new Date();
        //     this.data["search"] = false;
        //     this.assistBotService.chatHistoryList.unshift(this.data);
        //     this.assistBotService.historyListBheaviour.next({"templateName":"bot"});
        //   }
         
        // });
       
      },
      error:(error:HttpErrorResponse)=>{
        this.showPaginateSpinner= false;
        this.notifier.notify('error','Please Upload document'); this.data["question_type"]="history";
         
      }
  });
   
    
    } 


   


  }

  speakText(state:boolean,textdata:string){

    let voices = this.synth.getVoices();

    let speakLanguage:any, defaultVoice:any;

    if(this.speakeLanguage === 'hindi'){
      speakLanguage = 'Google हिन्दी';
      defaultVoice = 'Microsoft Kalpana - Hindi (India)';
    }else if(this.speakeLanguage === 'spanish'){
      speakLanguage = 'Google español';
      defaultVoice = 'Microsoft Helena - Spanish (Spain)';
    }else{
      speakLanguage = 'Google UK English Female';
      defaultVoice = 'Microsoft Heera - English (India)';
    }

     let botVoice = voices.findIndex(
      (items) => {
        items.name === speakLanguage
      }
    );
    let botDefaultVoice = voices.findIndex(
      (items) => {
        items.name === defaultVoice}
    );


    let text = textdata.replace(/(<([^>]+)>)/gi, "");
    if ('speechSynthesis' in window) {
       var utterThis = new SpeechSynthesisUtterance(text);

       utterThis.voice =
      botVoice > -1 ? voices[botVoice] : voices[botDefaultVoice];
       if(state){
        speechSynthesis.cancel();
        if (this.speakeLanguage === 'hindi') {
          utterThis.lang = 'hi-IN'
        }else if(this.speakeLanguage === 'spanish'){
          utterThis.lang = 'es-ES'
        }else{
          utterThis.lang = 'en-IN'
        }
        // utterThis.lang = this.speakeLanguage === 'hindi' ? 'hi-IN' : this.speakeLanguage;
        // console.log(utterThis, 'speach');

        window.speechSynthesis.speak(utterThis);
       }else{
        speechSynthesis.cancel();
       }

     } else {
         console.log('not support ');
     }
}

showFeedbackform(){
  this.isActiveFeedback =!this.isActiveFeedback;
  console.log( this.isActiveFeedback, 'isActive');
  
}

changeNewLine(answer:any){
  return answer.replace(/\n\r?/g, '<br />');
}
  

refresh(){
  this.data['created_at'] = new Date();
}

 

 



}
